export default __webpack_public_path__ + "static/screenshot-3-9d8667f6d05eb3a9e99975d8d5e3723e.png";